import { render, staticRenderFns } from "./TalkGameView.vue?vue&type=template&id=f4942532&"
import script from "./TalkGameView.vue?vue&type=script&lang=js&"
export * from "./TalkGameView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../.nvm/versions/node/v16.15.0/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
